/* eslint-disable camelcase */
/* eslint-disable @typescript-eslint/no-explicit-any */
import { FC } from 'react';
import { useTranslations } from 'next-intl';
import { useDispatch } from 'react-redux';
import { AuthDecorator } from '@components/auth-decorator';
import { BiddingCountDown } from '@components/bidding-countdown';
import { Button } from '@components/design-system';
import { actions } from '@state/modals';
import { MutToTez } from '@utils/format';

interface IBid {
  auction_id: number;
  current_bid: number;
  end_time: string;
  current_bidder?: any;
}

export const Bid: FC<IBid> = ({ auction_id, current_bid, end_time, current_bidder }) => {
  const t = useTranslations('market');
  const dispatch = useDispatch();

  const handleAuctionBid = () => {
    dispatch({
      type: actions.MODALS_SET_MODAL,
      payload: {
        type: 'auction-bid',
        auctionId: auction_id,
        currentBid: current_bid,
        isMinBid: current_bidder === null,
      },
    });
  };

  return (
    <>
      <BiddingCountDown
        currentBid={MutToTez(current_bid)}
        auctionEnd={new Date(end_time).getTime()}
        isMinBid={current_bidder === null}
      />
      <AuthDecorator onClick={handleAuctionBid}>
        <Button full variant="primary">
          {t('bid')}
        </Button>
      </AuthDecorator>
    </>
  );
};
